import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'IhmAutocompleteHighlight'
})
export class IhmAutocompleteHighlightPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (args === '') {
      return value;
    }

    return value.replace(new RegExp(args, 'gi'), match => {
      return `<span class="highlight">${match}</span>`;
    });
  }
}
